import { ArrowCircleUp } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import FormLabel from '@mui/material/FormLabel';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import ListItemButton from '@mui/material/ListItemButton';
import TaskDefinitionAutocomplete from '../../../../../../../components/Autocompletes/TaskDefinition';
import TagList from '../../../../../../../components/TagList';

export const DataFormComponent = (props) => {
  const {
    eventTemplate,
    handleChangeChildren,
    isLoading,
    navigate,
  } = props;

  if (isLoading) {
    return (
      <Card sx={{ width: '100%' }}>
        <CardHeader
          title="Calendar Type Tasks<"
          subheader="Define any tasks you may want to associate with this calendar event so they are available during scheduling."
        />
        <CardContent>
          <Skeleton height={40} sx={{ mb: 2 }} />
          <Skeleton height={40} sx={{ mb: 2 }} />
          <Skeleton height={40} />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        sx={{ mb: 2 }}
        title="Calendar Tasks"
        subheader="Define any tasks you want to associate with this calendar event so they are available during scheduling."
      />
      <CardContent>
        <Grid
          size={{
            xs: 12,
            md: 9,
            lg: 9,
          }}
        >
          <Grid container spacing={4}>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Stack spacing={2}>
                {/* <Typography variant="h6">Associated & Available Tasks</Typography>
                <Typography variant="body2" color="text.secondary">
                  Tasks selected below will be presented to the scheduler to optionally attach to the event.
                </Typography> */}
                <TaskDefinitionAutocomplete
                  label="Select Tasks To Associate"
                  startAdornmentIcon={<AddIcon />}
                  eventTemplates={null}
                  onSelect={(e, taskDefinition) => {
                    handleChangeChildren([...eventTemplate.children, taskDefinition]);
                  }}
                  exludeTagIds={[...eventTemplate.children.map((et) => et.id)]}
                  includeEventTaskTypeTagId={false}
                />
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mt: 1,
                  }}
                >
                  <ArrowCircleUp color="secondary" />
                  <Typography
                    sx={{
                      fontWeight: 300,
                      fontSize: 14,
                      ml: 1,
                    }}
                  >
                    Search for a task above to associate it with this calendar type.
                  </Typography>
                </Box>
                <Alert severity="info">
                  <Grid container justifyContent="space-between">
                    <Grid size={12}>
                      Tasks are optional when scheduling a calendar event. If you plan to associate tasks, choose which ones are available here.
                    </Grid>
                    <Grid
                      sx={{
                        justifyContent: 'flex-end',
                        mt: 1,
                        display: 'flex',
                        alignItems: 'center',
                      }}
                      size={12}
                    >
                      <Typography variant="caption" sx={{ mr: 1 }}>
                        Don&#39;t see the right task type?
                      </Typography>
                      <Button sx={{ py: 0 }} size="small" onClick={() => { if (navigate) { navigate('/settings/tasks') } else { window.location.href = '/settings/tasks' } }}>
                        Manage Task Types
                      </Button>
                    </Grid>
                  </Grid>
                </Alert>
              </Stack>
            </Grid>
            <Grid
              size={{
                xs: 12,
                md: 6,
              }}
            >
              <Stack spacing={2}>
                <FormControl fullWidth variant="outlined">
                  <FormLabel>Selected Tasks</FormLabel>
                  {
                    eventTemplate.children && eventTemplate.children.length === 0 && (
                      <Alert severity="warning" variant="outlined" sx={{ mt: 1 }}>
                        No tasks currently associated with this calendar type.
                      </Alert>
                    )
                  }
                  <List sx={{ py: 0 }}>
                    {eventTemplate.children.map((et) => (
                      <ListItemButton
                        divider
                        dense
                        key={`task-child-${et.id}`}
                        alignItems="flex-start"
                      >
                        <ListItemText
                          primary={et.name}
                          secondaryTypographyProps={{ component: 'div' }}
                          secondary={(
                            <Box>
                              <TagList tags={et.tags} size="small" />
                              <div>{et.description}</div>
                            </Box>
                          )}
                        />
                        <IconButton edge="end" aria-label="delete" onClick={() => handleChangeChildren(eventTemplate.children.filter((fet) => fet.id !== et.id))}>
                          <DeleteIcon />
                        </IconButton>
                      </ListItemButton>
                    ))}
                  </List>
                </FormControl>
              </Stack>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

DataFormComponent.propTypes = {
  eventTemplate: PropTypes.object,
  handleChangeChildren: PropTypes.func,
  isLoading: PropTypes.bool,
  navigate: PropTypes.func,
};

DataFormComponent.defaultProps = {
  eventTemplate: {},
  handleChangeChildren: () => { },
  isLoading: true,
  navigate: null,
};

export default DataFormComponent;
